// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* stylelint-disable selector-class-pattern */\n.tabmenu--tabs {\n  display: flex; }\n  .tabmenu--tabs .tab {\n    font-weight: 500;\n    cursor: pointer; }\n    .tabmenu--tabs .tab:focus {\n      outline: none; }\n\n.tabmenu--content .hidden {\n  display: none; }\n", ""]);
// Exports
module.exports = exports;
